import { render, staticRenderFns } from "./ImageSettings.vue?vue&type=template&id=b8c3a434&scoped=true"
import script from "./ImageSettings.vue?vue&type=script&lang=ts"
export * from "./ImageSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c3a434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8c3a434')) {
      api.createRecord('b8c3a434', component.options)
    } else {
      api.reload('b8c3a434', component.options)
    }
    module.hot.accept("./ImageSettings.vue?vue&type=template&id=b8c3a434&scoped=true", function () {
      api.rerender('b8c3a434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/ImageSettings.vue"
export default component.exports